function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Browser");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Calendar---Events-Calendar",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1.-Calendar---Filters---Selected",
  transform: "translate(-1187.000000, -564.000000)",
  fill: "#5B6C7A",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Filters",
  transform: "translate(701.000000, 322.006646)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(20.000000, 197.993354)"
}, /*#__PURE__*/React.createElement("g", {
  id: "7.-Small-Components/7.4-Labels-and-Pills/Pills/Filters/Unselected-Copy-13",
  transform: "translate(454.000000, 36.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "4.-Icons/Small/Solid/Gray",
  transform: "translate(8.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "4.-Icons/Calendar/12px/Dark",
  transform: "translate(-0.500000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.8749741,14.7499982 C16.4960663,14.7499982 16.9999714,14.2460932 16.9999714,13.6250009 L16.9999714,5.37502056 C16.9999714,4.75392829 16.4960663,4.25002325 15.8749741,4.25002325 L6.12499732,4.25002325 C5.50390505,4.25002325 5,4.75392829 5,5.37502056 L5,13.6250009 C5,14.2460932 5.50390505,14.7499982 6.12499732,14.7499982 L15.8749741,14.7499982 Z M7.71874352,7.25001967 L6.78124575,7.25001967 C6.62656778,7.25001967 6.49999642,7.12344474 6.49999642,6.96876676 L6.49999642,6.031269 C6.49999642,5.87659102 6.62656778,5.75001967 6.78124575,5.75001967 L7.71874352,5.75001967 C7.87342149,5.75001967 7.99999642,5.87659102 7.99999642,6.031269 L7.99999642,6.96876676 C7.99999642,7.12344474 7.87342149,7.25001967 7.71874352,7.25001967 Z M15.2187256,7.25001967 L9.40623949,7.25001967 C9.25156152,7.25001967 9.12499017,7.12344474 9.12499017,6.96876676 L9.12499017,6.031269 C9.12499017,5.87659102 9.25156152,5.75001967 9.40623949,5.75001967 L15.2187256,5.75001967 C15.3734036,5.75001967 15.499975,5.87659102 15.499975,6.031269 L15.499975,6.96876676 C15.499975,7.12344474 15.3734036,7.25001967 15.2187256,7.25001967 Z",
  id: "Browser"
}))))))));

var SvgOnline = function SvgOnline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "11px",
    viewBox: "0 0 13 11",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOnline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Online.d46d4c53.svg";
export { ForwardRef as ReactComponent };